

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {flattenErrors} from "@/helpers/errorsHelper";

  // export interface FieldEditorConfig {
  //   // textfield|select|radio
  //   type?: string;
  //   title?: string;
  //   description?: string;
  //   label?: string;
  //   value: any;
  //   values?: object;
  //   rules?: any[];
  //   event?: string;
  //   data?: object;
  // }

  @Component({
    name: 'FieldEditor',
  })
  export default class FieldEditor extends Vue {

    protected showing: boolean = false;
    protected type: string = 'textfield';
    protected title: string = '';
    protected description: string = '';
    protected label: string = '';
    protected value: any = '';
    protected values: any[] = [];
    protected rules: any[] = [];
    protected event: string = '';
    protected data: any = {};
    protected originalValue: string = '';
    protected errors: string[] = [];
    protected disabled: boolean = false;
    protected subscribes: object = {};

    created() {
      this.subscribes = this.$ons({
        'field-editor.show': this.onShow,
        'backend.call.begin': this.onDisable,
        'backend.call.OK': this.onHide,
        'backend.call.KO': this.onError,
      });
    }
    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    protected onSubmit() {
      if (this.value == this.originalValue) {
        this.errors = ['Sin cambio'];
        return;
      }
      if (this.event) {
        this.$uiBus.emit(this.event, this.value, this.data);
      }
      else {
        this.$uiBus.emit('field-editor.value', this.value, this.data);
        this.$emit('submitted', this.value, this.data);
      }
    }
    protected onShow(props: any) {
      this.type = props.type || 'textfield';
      this.title = props.title || '';
      this.description = props.description || '';
      this.label = props.label || '';
      this.value = props.value === undefined ? '' : props.value;
      this.values = props.values || {};
      this.rules = props.rules || [];
      this.event = props.event || '';
      this.data = props.data || {};
      this.errors = props.errors || [];
      this.originalValue = this.value;
      this.disabled = false;
      this.showing = true;
    }
    protected onDisable() {
      this.disabled = true;
    }
    protected onError(mutationName: string, error: any) {
      this.errors = flattenErrors(error);
      this.disabled = false;
    }
    protected onHide() {
      this.showing = false;
    }
  }

